function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import * as React from 'react';
import { createClient as createClient$1, getProvider, watchProvider, getWebSocketProvider, watchWebSocketProvider, fetchBlockNumber, fetchFeeData, deepEqual, getAccount, watchAccount, fetchBalance, connect, disconnect, getNetwork, watchNetwork, watchSigner, fetchSigner, signMessage, signTypedData, switchNetwork, getContract, readContracts, parseContractResult, readContract, writeContract, fetchToken, fetchEnsAddress, fetchEnsAvatar, fetchEnsName, fetchEnsResolver, sendTransaction, waitForTransaction } from '@wagmi/core';
export { AddChainError, ChainDoesNotSupportMulticallError, ChainMismatchError, ChainNotConfiguredError, Client, Connector, ConnectorAlreadyConnectedError, ConnectorNotFoundError, ContractMethodNoResultError, ProviderChainsNotFound, ProviderRpcError, ResourceUnavailableError, RpcError, SwitchChainError, SwitchChainNotSupportedError, UserRejectedRequestError, alchemyRpcUrls, allChains, chain, chainId, configureChains, createStorage, deepEqual, defaultChains, defaultL2Chains, erc20ABI, erc721ABI, etherscanBlockExplorers, infuraRpcUrls, publicRpcUrls, readContracts } from '@wagmi/core';
import { QueryClient, QueryClientProvider, useQueryClient, useIsRestoring, useQueryErrorResetBoundary, notifyManager, InfiniteQueryObserver, QueryObserver, useMutation, hashQueryKey } from 'react-query';
import { persistQueryClient } from 'react-query/persistQueryClient';
import { createWebStoragePersister } from 'react-query/createWebStoragePersister';
import { BigNumber } from 'ethers/lib/ethers';
import * as pkg from 'use-sync-external-store/shim/index.js';
import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/shim/with-selector.js';

var findAndReplace = function findAndReplace(cacheRef, _ref) {
  var find = _ref.find,
      replace = _ref.replace;

  if (cacheRef && find(cacheRef)) {
    return replace(cacheRef);
  }

  if (_typeof(cacheRef) !== 'object') {
    return cacheRef;
  }

  if (Array.isArray(cacheRef)) {
    return cacheRef.map(function (item) {
      return findAndReplace(item, {
        find: find,
        replace: replace
      });
    });
  }

  if (cacheRef instanceof Object) {
    return Object.entries(cacheRef).reduce(function (curr, _ref2) {
      var _ref6 = _slicedToArray(_ref2, 2),
          key = _ref6[0],
          value = _ref6[1];

      return _objectSpread(_objectSpread({}, curr), {}, _defineProperty({}, key, findAndReplace(value, {
        find: find,
        replace: replace
      })));
    }, {});
  }

  return cacheRef;
};

function deserialize(cachedString) {
  var cache = JSON.parse(cachedString);
  var deserializedCacheWithBigNumbers = findAndReplace(cache, {
    find: function find(data) {
      return data.type === 'BigNumber';
    },
    replace: function replace(data) {
      return BigNumber.from(data.hex);
    }
  });
  return deserializedCacheWithBigNumbers;
}
/**
 * @function getReferenceKey
 *
 * @description
 * get the reference key for the circular value
 *
 * @param keys the keys to build the reference key from
 * @param cutoff the maximum number of keys to include
 * @returns the reference key
 */


function getReferenceKey(keys, cutoff) {
  return keys.slice(0, cutoff).join('.') || '.';
}
/**
 * @function getCutoff
 *
 * @description
 * faster `Array.prototype.indexOf` implementation build for slicing / splicing
 *
 * @param array the array to match the value in
 * @param value the value to match
 * @returns the matching index, or -1
 */


function getCutoff(array, value) {
  var length = array.length;

  for (var index = 0; index < length; ++index) {
    if (array[index] === value) {
      return index + 1;
    }
  }

  return 0;
}
/**
 * @function createReplacer
 *
 * @description
 * create a replacer method that handles circular values
 *
 * @param [replacer] a custom replacer to use for non-circular values
 * @param [circularReplacer] a custom replacer to use for circular methods
 * @returns the value to stringify
 */


function createReplacer(replacer, circularReplacer) {
  var hasReplacer = typeof replacer === 'function';
  var hasCircularReplacer = typeof circularReplacer === 'function';
  var cache = [];
  var keys = [];
  return function replace(key, value) {
    if (_typeof(value) === 'object') {
      if (cache.length) {
        var thisCutoff = getCutoff(cache, this);

        if (thisCutoff === 0) {
          cache[cache.length] = this;
        } else {
          cache.splice(thisCutoff);
          keys.splice(thisCutoff);
        }

        keys[keys.length] = key;
        var valueCutoff = getCutoff(cache, value);

        if (valueCutoff !== 0) {
          return hasCircularReplacer ? circularReplacer.call(this, key, value, getReferenceKey(keys, valueCutoff)) : "[ref=".concat(getReferenceKey(keys, valueCutoff), "]");
        }
      } else {
        cache[0] = value;
        keys[0] = key;
      }
    }

    return hasReplacer ? replacer.call(this, key, value) : value;
  };
}
/**
 * @function stringify
 *
 * @description
 * stringifier that handles circular values
 * Forked from https://github.com/planttheidea/fast-stringify
 *
 * @param value to stringify
 * @param [replacer] a custom replacer function for handling standard values
 * @param [indent] the number of spaces to indent the output by
 * @param [circularReplacer] a custom replacer function for handling circular values
 * @returns the stringified output
 */


function serialize(value, replacer, indent, circularReplacer) {
  return JSON.stringify(value, createReplacer(replacer, circularReplacer), indent !== null && indent !== void 0 ? indent : undefined);
}

function createClient(_ref) {
  var _ref$queryClient = _ref.queryClient,
      queryClient = _ref$queryClient === void 0 ? new QueryClient({
    defaultOptions: {
      queries: {
        cacheTime: 1000 * 60 * 60 * 24,
        // 24 hours
        networkMode: 'offlineFirst',
        refetchOnWindowFocus: false,
        retry: 0
      },
      mutations: {
        networkMode: 'offlineFirst'
      }
    }
  }) : _ref$queryClient,
      _ref$persister = _ref.persister,
      persister = _ref$persister === void 0 ? typeof window !== 'undefined' ? createWebStoragePersister({
    key: 'wagmi.cache',
    storage: window.localStorage,
    serialize: serialize,
    deserialize: deserialize
  }) : undefined : _ref$persister,
      config = _objectWithoutProperties(_ref, ["queryClient", "persister"]);

  var client = createClient$1(config);
  if (persister) persistQueryClient({
    queryClient: queryClient,
    persister: persister,
    dehydrateOptions: {
      shouldDehydrateQuery: function shouldDehydrateQuery(query) {
        return query.cacheTime !== 0;
      }
    }
  });
  return Object.assign(client, {
    queryClient: queryClient
  });
}

var Context = /*#__PURE__*/React.createContext(undefined);

function WagmiConfig(_ref2) {
  var children = _ref2.children,
      client = _ref2.client; // Attempt to connect on mount

  React.useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (client.config.autoConnect) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              _context.next = 4;
              return client.autoConnect();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))(); // eslint-disable-next-line react-hooks/exhaustive-deps

  }, []);
  return /*#__PURE__*/React.createElement(Context.Provider, {
    value: client
  }, /*#__PURE__*/React.createElement(QueryClientProvider, {
    client: client.queryClient
  }, children));
}

function useClient() {
  var client = React.useContext(Context);
  if (!client) throw new Error(['`useClient` must be used within `WagmiConfig`.\n', 'Read more: https://wagmi.sh/docs/WagmiConfig'].join('\n'));
  return client;
}

var useSyncExternalStore = pkg.useSyncExternalStore;

function isQueryKey(value) {
  return Array.isArray(value);
}

function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return _objectSpread(_objectSpread({}, arg3), {}, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return _objectSpread(_objectSpread({}, arg2), {}, {
    queryKey: arg1
  });
}

function shouldThrowError(_useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary.apply(void 0, _toConsumableArray(params));
  }

  return !!_useErrorBoundary;
}

function trackResult(result, observer) {
  var trackedResult = {};
  Object.keys(result).forEach(function (key) {
    Object.defineProperty(trackedResult, key, {
      configurable: false,
      enumerable: true,
      get: function get() {
        // @ts-expect-error – aware we are mutating private `trackedProps` property.
        observer.trackedProps.add(key);
        return result[key];
      }
    });
  });
  return trackedResult;
}

function useBaseQuery(options, Observer) {
  var queryClient = useQueryClient({
    context: options.context
  });
  var isRestoring = useIsRestoring();
  var errorResetBoundary = useQueryErrorResetBoundary();
  var defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic'; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager.batchCalls(defaultedOptions.onSettled);
  }

  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    }
  }

  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }

  var _React$useState = React.useState(function () {
    return new Observer(queryClient, defaultedOptions);
  }),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      observer = _React$useState2[0];

  var result = observer.getOptimisticResult(defaultedOptions);
  useSyncExternalStore(React.useCallback(function (onStoreChange) {
    return isRestoring ? function () {
      return undefined;
    } : observer.subscribe(notifyManager.batchCalls(onStoreChange));
  }, [observer, isRestoring]), function () {
    return observer.getCurrentResult();
  }, function () {
    return observer.getCurrentResult();
  });
  React.useEffect(function () {
    errorResetBoundary.clearReset();
  }, [errorResetBoundary]);
  React.useEffect(function () {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (defaultedOptions.suspense && result.isLoading && result.isFetching && !isRestoring) {
    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref) {
      var _defaultedOptions$onS, _defaultedOptions$onS2;

      var data = _ref.data;
      (_defaultedOptions$onS = defaultedOptions.onSuccess) === null || _defaultedOptions$onS === void 0 ? void 0 : _defaultedOptions$onS.call(defaultedOptions, data);
      (_defaultedOptions$onS2 = defaultedOptions.onSettled) === null || _defaultedOptions$onS2 === void 0 ? void 0 : _defaultedOptions$onS2.call(defaultedOptions, data, null);
    })["catch"](function (error) {
      var _defaultedOptions$onE, _defaultedOptions$onS3;

      errorResetBoundary.clearReset();
      (_defaultedOptions$onE = defaultedOptions.onError) === null || _defaultedOptions$onE === void 0 ? void 0 : _defaultedOptions$onE.call(defaultedOptions, error);
      (_defaultedOptions$onS3 = defaultedOptions.onSettled) === null || _defaultedOptions$onS3 === void 0 ? void 0 : _defaultedOptions$onS3.call(defaultedOptions, undefined, error);
    });
  } // Handle error boundary


  if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && shouldThrowError(defaultedOptions.useErrorBoundary, [result.error, observer.getCurrentQuery()])) {
    throw result.error;
  }

  var status = result.status === 'loading' && result.fetchStatus === 'idle' ? 'idle' : result.status;
  var isIdle = status === 'idle';
  var isLoading = status === 'loading' && result.fetchStatus === 'fetching';
  return _objectSpread(_objectSpread({}, result), {}, {
    defaultedOptions: defaultedOptions,
    isIdle: isIdle,
    isLoading: isLoading,
    observer: observer,
    status: status
  });
}

function useInfiniteQuery(arg1, arg2, arg3) {
  var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
  var baseQuery = useBaseQuery(parsedOptions, InfiniteQueryObserver);
  var result = {
    data: baseQuery.data,
    error: baseQuery.error,
    fetchNextPage: baseQuery.fetchNextPage,
    fetchStatus: baseQuery.fetchStatus,
    hasNextPage: baseQuery.hasNextPage,
    isError: baseQuery.isError,
    isFetched: baseQuery.isFetched,
    isFetching: baseQuery.isFetching,
    isFetchingNextPage: baseQuery.isFetchingNextPage,
    isIdle: baseQuery.isIdle,
    isLoading: baseQuery.isLoading,
    isRefetching: baseQuery.isRefetching,
    isSuccess: baseQuery.isSuccess,
    refetch: baseQuery.refetch,
    status: baseQuery.status,
    internal: {
      dataUpdatedAt: baseQuery.dataUpdatedAt,
      errorUpdatedAt: baseQuery.errorUpdatedAt,
      failureCount: baseQuery.failureCount,
      isFetchedAfterMount: baseQuery.isFetchedAfterMount,
      isLoadingError: baseQuery.isLoadingError,
      isPaused: baseQuery.isPaused,
      isPlaceholderData: baseQuery.isPlaceholderData,
      isPreviousData: baseQuery.isPreviousData,
      isRefetchError: baseQuery.isRefetchError,
      isStale: baseQuery.isStale,
      remove: baseQuery.remove
    }
  }; // Handle result property usage tracking

  return !baseQuery.defaultedOptions.notifyOnChangeProps ? trackResult(result, baseQuery.observer) : result;
}

function useQuery(arg1, arg2, arg3) {
  var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
  var baseQuery = useBaseQuery(parsedOptions, QueryObserver);
  var result = {
    data: baseQuery.data,
    error: baseQuery.error,
    fetchStatus: baseQuery.fetchStatus,
    isError: baseQuery.isError,
    isFetched: baseQuery.isFetched,
    isFetching: baseQuery.isFetching,
    isIdle: baseQuery.isIdle,
    isLoading: baseQuery.isLoading,
    isRefetching: baseQuery.isRefetching,
    isSuccess: baseQuery.isSuccess,
    refetch: baseQuery.refetch,
    status: baseQuery.status,
    internal: {
      dataUpdatedAt: baseQuery.dataUpdatedAt,
      errorUpdatedAt: baseQuery.errorUpdatedAt,
      failureCount: baseQuery.failureCount,
      isFetchedAfterMount: baseQuery.isFetchedAfterMount,
      isLoadingError: baseQuery.isLoadingError,
      isPaused: baseQuery.isPaused,
      isPlaceholderData: baseQuery.isPlaceholderData,
      isPreviousData: baseQuery.isPreviousData,
      isRefetchError: baseQuery.isRefetchError,
      isStale: baseQuery.isStale,
      remove: baseQuery.remove
    }
  }; // Handle result property usage tracking

  return !baseQuery.defaultedOptions.notifyOnChangeProps ? trackResult(result, baseQuery.observer) : result;
}

function useProvider() {
  var _ref8 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId = _ref8.chainId;

  var forceUpdate = useForceUpdate();
  var client = useClient();
  var provider = React.useRef(getProvider({
    chainId: chainId
  }));
  React.useEffect(function () {
    var unwatch = watchProvider({
      chainId: chainId
    }, function (provider_) {
      provider.current = provider_;
      forceUpdate();
    });
    return unwatch;
  }, [chainId, client, forceUpdate]);
  return provider.current;
}

function useWebSocketProvider() {
  var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId = _ref9.chainId;

  var forceUpdate = useForceUpdate();
  var client = useClient();
  var webSocketProvider = React.useRef(getWebSocketProvider({
    chainId: chainId
  }));
  React.useEffect(function () {
    var unwatch = watchWebSocketProvider({
      chainId: chainId
    }, function (webSocketProvider_) {
      webSocketProvider.current = webSocketProvider_;
      forceUpdate();
    });
    return unwatch;
  }, [chainId, client, forceUpdate]);
  return webSocketProvider.current;
}

function useChainId() {
  var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId = _ref10.chainId;

  var provider = useProvider({
    chainId: chainId
  });
  return provider.network.chainId;
}

function useForceUpdate() {
  var _React$useReducer = React.useReducer(function (x) {
    return x + 1;
  }, 0),
      _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
      forceUpdate = _React$useReducer2[1];

  return forceUpdate;
}

var queryKey$c = function queryKey$c(_ref) {
  var chainId = _ref.chainId;
  return [{
    entity: 'blockNumber',
    chainId: chainId
  }];
};

var queryFn$c = function queryFn$c(_ref2) {
  var _ref2$queryKey = _slicedToArray(_ref2.queryKey, 1),
      chainId = _ref2$queryKey[0].chainId;

  return fetchBlockNumber({
    chainId: chainId
  });
};

function useBlockNumber() {
  var _ref11 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref11$cacheTime = _ref11.cacheTime,
      cacheTime = _ref11$cacheTime === void 0 ? 0 : _ref11$cacheTime,
      chainId_ = _ref11.chainId,
      _ref11$enabled = _ref11.enabled,
      enabled = _ref11$enabled === void 0 ? true : _ref11$enabled,
      staleTime = _ref11.staleTime,
      suspense = _ref11.suspense,
      _ref11$watch = _ref11.watch,
      watch = _ref11$watch === void 0 ? false : _ref11$watch,
      onBlock = _ref11.onBlock,
      onError = _ref11.onError,
      onSettled = _ref11.onSettled,
      onSuccess = _ref11.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  var provider = useProvider();
  var webSocketProvider = useWebSocketProvider();
  var queryClient = useQueryClient();
  React.useEffect(function () {
    if (!watch && !onBlock) return;

    var listener = function listener(blockNumber) {
      // Just to be safe in case the provider implementation
      // calls the event callback after .off() has been called
      if (watch) queryClient.setQueryData(queryKey$c({
        chainId: chainId
      }), blockNumber);
      if (onBlock) onBlock(blockNumber);
    };

    var provider_ = webSocketProvider !== null && webSocketProvider !== void 0 ? webSocketProvider : provider;
    provider_.on('block', listener);
    return function () {
      provider_.off('block', listener);
    };
  }, [chainId, onBlock, provider, queryClient, watch, webSocketProvider]);
  return useQuery(queryKey$c({
    chainId: chainId
  }), queryFn$c, {
    cacheTime: cacheTime,
    enabled: enabled,
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
}

var queryKey$b = function queryKey$b(_ref) {
  var chainId = _ref.chainId,
      formatUnits = _ref.formatUnits;
  return [{
    entity: 'feeData',
    chainId: chainId,
    formatUnits: formatUnits
  }];
};

var queryFn$b = function queryFn$b(_ref2) {
  var _ref2$queryKey2 = _slicedToArray(_ref2.queryKey, 1),
      _ref2$queryKey2$ = _ref2$queryKey2[0],
      chainId = _ref2$queryKey2$.chainId,
      formatUnits = _ref2$queryKey2$.formatUnits;

  return fetchFeeData({
    chainId: chainId,
    formatUnits: formatUnits
  });
};

function useFeeData() {
  var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      cacheTime = _ref12.cacheTime,
      chainId_ = _ref12.chainId,
      _ref12$enabled = _ref12.enabled,
      enabled = _ref12$enabled === void 0 ? true : _ref12$enabled,
      _ref12$formatUnits = _ref12.formatUnits,
      formatUnits = _ref12$formatUnits === void 0 ? 'wei' : _ref12$formatUnits,
      staleTime = _ref12.staleTime,
      suspense = _ref12.suspense,
      watch = _ref12.watch,
      onError = _ref12.onError,
      onSettled = _ref12.onSettled,
      onSuccess = _ref12.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  var feeDataQuery = useQuery(queryKey$b({
    chainId: chainId,
    formatUnits: formatUnits
  }), queryFn$b, {
    cacheTime: cacheTime,
    enabled: enabled,
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });

  var _useBlockNumber = useBlockNumber({
    watch: watch
  }),
      blockNumber = _useBlockNumber.data;

  React.useEffect(function () {
    if (!enabled) return;
    if (!watch) return;
    if (!blockNumber) return;
    feeDataQuery.refetch(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blockNumber]);
  return feeDataQuery;
}

function useInvalidateOnBlock(_ref) {
  var enabled = _ref.enabled,
      queryKey = _ref.queryKey;
  var queryClient = useQueryClient();
  useBlockNumber({
    onBlock: enabled ? function () {
      return queryClient.invalidateQueries(queryKey);
    } : undefined
  });
}

var isPlainObject = function isPlainObject(obj) {
  return _typeof(obj) === 'object' && !Array.isArray(obj);
};

function useSyncExternalStoreWithTracked(subscribe, getSnapshot) {
  var getServerSnapshot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getSnapshot;
  var isEqual = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function (a, b) {
    return deepEqual(a, b);
  };
  var trackedKeys = React.useRef([]);
  var result = useSyncExternalStoreWithSelector(subscribe, getSnapshot, getServerSnapshot, function (x) {
    return x;
  }, function (a, b) {
    if (isPlainObject(a) && isPlainObject(b)) {
      var _iterator = _createForOfIteratorHelper(trackedKeys.current),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          var equal = isEqual(a[key], b[key]);
          if (!equal) return false;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return true;
    }

    return isEqual(a, b);
  });

  if (isPlainObject(result)) {
    var trackedResult = _objectSpread({}, result);

    Object.defineProperties(trackedResult, Object.entries(trackedResult).reduce(function (res, _ref) {
      var _ref13 = _slicedToArray(_ref, 2),
          key = _ref13[0],
          value = _ref13[1];

      return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          if (!trackedKeys.current.includes(key)) {
            trackedKeys.current.push(key);
          }

          return value;
        }
      }));
    }, {}));
    return trackedResult;
  }

  return result;
}

function useAccount() {
  var _ref14 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onConnect = _ref14.onConnect,
      onDisconnect = _ref14.onDisconnect;

  var account = useSyncExternalStoreWithTracked(watchAccount, getAccount);

  var _useClient = useClient(),
      subscribe = _useClient.subscribe;

  React.useEffect(function () {
    // No need to subscribe if these callbacks aren't defined
    if (!onConnect && !onDisconnect) return; // Trigger update when status changes

    var unsubscribe = subscribe(function (state) {
      return state.status;
    }, function (status, prevStatus) {
      if (!!onConnect && status === 'connected') {
        var _getAccount = getAccount(),
            address = _getAccount.address,
            connector = _getAccount.connector;

        onConnect({
          address: address,
          connector: connector,
          isReconnected: prevStatus === 'reconnecting'
        });
      }

      if (!!onDisconnect && prevStatus !== 'connecting' && status === 'disconnected') onDisconnect();
    });
    return unsubscribe;
  }, [onConnect, onDisconnect, subscribe]);
  return account;
}

var queryKey$a = function queryKey$a(_ref) {
  var addressOrName = _ref.addressOrName,
      chainId = _ref.chainId,
      formatUnits = _ref.formatUnits,
      token = _ref.token;
  return [{
    entity: 'balance',
    addressOrName: addressOrName,
    chainId: chainId,
    formatUnits: formatUnits,
    token: token
  }];
};

var queryFn$a = function queryFn$a(_ref2) {
  var _ref2$queryKey3 = _slicedToArray(_ref2.queryKey, 1),
      _ref2$queryKey3$ = _ref2$queryKey3[0],
      addressOrName = _ref2$queryKey3$.addressOrName,
      chainId = _ref2$queryKey3$.chainId,
      formatUnits = _ref2$queryKey3$.formatUnits,
      token = _ref2$queryKey3$.token;

  if (!addressOrName) throw new Error('address is required');
  return fetchBalance({
    addressOrName: addressOrName,
    chainId: chainId,
    formatUnits: formatUnits,
    token: token
  });
};

function useBalance() {
  var _ref15 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      addressOrName = _ref15.addressOrName,
      cacheTime = _ref15.cacheTime,
      chainId_ = _ref15.chainId,
      _ref15$enabled = _ref15.enabled,
      enabled = _ref15$enabled === void 0 ? true : _ref15$enabled,
      _ref15$formatUnits = _ref15.formatUnits,
      formatUnits = _ref15$formatUnits === void 0 ? 'ether' : _ref15$formatUnits,
      staleTime = _ref15.staleTime,
      suspense = _ref15.suspense,
      token = _ref15.token,
      watch = _ref15.watch,
      onError = _ref15.onError,
      onSettled = _ref15.onSettled,
      onSuccess = _ref15.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  var balanceQuery = useQuery(queryKey$a({
    addressOrName: addressOrName,
    chainId: chainId,
    formatUnits: formatUnits,
    token: token
  }), queryFn$a, {
    cacheTime: cacheTime,
    enabled: Boolean(enabled && addressOrName),
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });

  var _useBlockNumber2 = useBlockNumber({
    watch: watch
  }),
      blockNumber = _useBlockNumber2.data;

  React.useEffect(function () {
    if (!enabled) return;
    if (!watch) return;
    if (!blockNumber) return;
    if (!addressOrName) return;
    balanceQuery.refetch(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blockNumber]);
  return balanceQuery;
}

var mutationKey$6 = function mutationKey$6(args) {
  return [_objectSpread({
    entity: 'connect'
  }, args)];
};

var mutationFn$5 = function mutationFn$5(args) {
  var connector = args.connector,
      chainId = args.chainId;
  if (!connector) throw new Error('connector is required');
  return connect({
    connector: connector,
    chainId: chainId
  });
};

function useConnect() {
  var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId = _ref16.chainId,
      connector = _ref16.connector,
      onError = _ref16.onError,
      onMutate = _ref16.onMutate,
      onSettled = _ref16.onSettled,
      onSuccess = _ref16.onSuccess;

  var client = useClient();

  var _useMutation = useMutation(mutationKey$6({
    connector: connector,
    chainId: chainId
  }), mutationFn$5, {
    onError: onError,
    onMutate: onMutate,
    onSettled: onSettled,
    onSuccess: onSuccess
  }),
      data = _useMutation.data,
      error = _useMutation.error,
      isError = _useMutation.isError,
      isIdle = _useMutation.isIdle,
      isLoading = _useMutation.isLoading,
      isSuccess = _useMutation.isSuccess,
      mutate = _useMutation.mutate,
      mutateAsync = _useMutation.mutateAsync,
      reset = _useMutation.reset,
      status = _useMutation.status,
      variables = _useMutation.variables;

  var connect = React.useCallback(function (args) {
    var _args$chainId, _args$connector;

    return mutate({
      chainId: (_args$chainId = args === null || args === void 0 ? void 0 : args.chainId) !== null && _args$chainId !== void 0 ? _args$chainId : chainId,
      connector: (_args$connector = args === null || args === void 0 ? void 0 : args.connector) !== null && _args$connector !== void 0 ? _args$connector : connector
    });
  }, [chainId, connector, mutate]);
  var connectAsync = React.useCallback(function (args) {
    var _args$chainId2, _args$connector2;

    return mutateAsync({
      chainId: (_args$chainId2 = args === null || args === void 0 ? void 0 : args.chainId) !== null && _args$chainId2 !== void 0 ? _args$chainId2 : chainId,
      connector: (_args$connector2 = args === null || args === void 0 ? void 0 : args.connector) !== null && _args$connector2 !== void 0 ? _args$connector2 : connector
    });
  }, [chainId, connector, mutateAsync]);
  return {
    connect: connect,
    connectAsync: connectAsync,
    connectors: client.connectors,
    data: data,
    error: error,
    isError: isError,
    isIdle: isIdle,
    isLoading: isLoading,
    isSuccess: isSuccess,
    pendingConnector: variables === null || variables === void 0 ? void 0 : variables.connector,
    reset: reset,
    status: status,
    variables: variables
  };
}

var mutationKey$5 = [{
  entity: 'disconnect'
}];

var mutationFn$4 = function mutationFn$4() {
  return disconnect();
};

function useDisconnect() {
  var _ref17 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _onError = _ref17.onError,
      onMutate = _ref17.onMutate,
      _onSettled = _ref17.onSettled,
      _onSuccess = _ref17.onSuccess;

  var _useMutation2 = useMutation(mutationKey$5, mutationFn$4, _objectSpread(_objectSpread(_objectSpread({}, _onError ? {
    onError: function onError(error, _variables, context) {
      _onError(error, context);
    }
  } : {}), {}, {
    onMutate: onMutate
  }, _onSettled ? {
    onSettled: function onSettled(_data, error, _variables, context) {
      _onSettled(error, context);
    }
  } : {}), _onSuccess ? {
    onSuccess: function onSuccess(_data, _variables, context) {
      _onSuccess(context);
    }
  } : {})),
      error = _useMutation2.error,
      isError = _useMutation2.isError,
      isIdle = _useMutation2.isIdle,
      isLoading = _useMutation2.isLoading,
      isSuccess = _useMutation2.isSuccess,
      disconnect = _useMutation2.mutate,
      disconnectAsync = _useMutation2.mutateAsync,
      reset = _useMutation2.reset,
      status = _useMutation2.status;

  return {
    disconnect: disconnect,
    disconnectAsync: disconnectAsync,
    error: error,
    isError: isError,
    isIdle: isIdle,
    isLoading: isLoading,
    isSuccess: isSuccess,
    reset: reset,
    status: status
  };
}

function useNetwork() {
  return useSyncExternalStoreWithTracked(watchNetwork, getNetwork);
}

var queryKey$9 = function queryKey$9() {
  return [{
    entity: 'signer'
  }];
};

var queryFn$9 = function queryFn$9() {
  return fetchSigner();
};

function useSigner() {
  var _ref18 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      suspense = _ref18.suspense,
      onError = _ref18.onError,
      onSettled = _ref18.onSettled,
      onSuccess = _ref18.onSuccess;

  var signerQuery = useQuery(queryKey$9(), queryFn$9, {
    cacheTime: 0,
    staleTime: 0,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
  var queryClient = useQueryClient();
  React.useEffect(function () {
    var unwatch = watchSigner(function (signer) {
      return queryClient.setQueryData(queryKey$9(), signer);
    });
    return unwatch;
  }, [queryClient]);
  return signerQuery;
}

var mutationKey$4 = function mutationKey$4(args) {
  return [_objectSpread({
    entity: 'signMessage'
  }, args)];
};

var mutationFn$3 = function mutationFn$3(args) {
  var message = args.message;
  if (!message) throw new Error('message is required');
  return signMessage({
    message: message
  });
};

function useSignMessage() {
  var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      message = _ref19.message,
      onError = _ref19.onError,
      onMutate = _ref19.onMutate,
      onSettled = _ref19.onSettled,
      onSuccess = _ref19.onSuccess;

  var _useMutation3 = useMutation(mutationKey$4({
    message: message
  }), mutationFn$3, {
    onError: onError,
    onMutate: onMutate,
    onSettled: onSettled,
    onSuccess: onSuccess
  }),
      data = _useMutation3.data,
      error = _useMutation3.error,
      isError = _useMutation3.isError,
      isIdle = _useMutation3.isIdle,
      isLoading = _useMutation3.isLoading,
      isSuccess = _useMutation3.isSuccess,
      mutate = _useMutation3.mutate,
      mutateAsync = _useMutation3.mutateAsync,
      reset = _useMutation3.reset,
      status = _useMutation3.status,
      variables = _useMutation3.variables;

  var signMessage = React.useCallback(function (args) {
    return mutate(args || {
      message: message
    });
  }, [message, mutate]);
  var signMessageAsync = React.useCallback(function (args) {
    return mutateAsync(args || {
      message: message
    });
  }, [message, mutateAsync]);
  return {
    data: data,
    error: error,
    isError: isError,
    isIdle: isIdle,
    isLoading: isLoading,
    isSuccess: isSuccess,
    reset: reset,
    signMessage: signMessage,
    signMessageAsync: signMessageAsync,
    status: status,
    variables: variables
  };
}

var mutationKey$3 = function mutationKey$3(args) {
  return [_objectSpread({
    entity: 'signTypedData'
  }, args)];
};

var mutationFn$2 = function mutationFn$2(args) {
  var domain = args.domain,
      types = args.types,
      value = args.value;
  if (!domain || !types || !value) throw new Error('domain, types, and value are all required');
  return signTypedData({
    domain: domain,
    types: types,
    value: value
  });
};

function useSignTypedData() {
  var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      domain = _ref20.domain,
      types = _ref20.types,
      value = _ref20.value,
      onError = _ref20.onError,
      onMutate = _ref20.onMutate,
      onSettled = _ref20.onSettled,
      onSuccess = _ref20.onSuccess;

  var _useMutation4 = useMutation(mutationKey$3({
    domain: domain,
    types: types,
    value: value
  }), mutationFn$2, {
    onError: onError,
    onMutate: onMutate,
    onSettled: onSettled,
    onSuccess: onSuccess
  }),
      data = _useMutation4.data,
      error = _useMutation4.error,
      isError = _useMutation4.isError,
      isIdle = _useMutation4.isIdle,
      isLoading = _useMutation4.isLoading,
      isSuccess = _useMutation4.isSuccess,
      mutate = _useMutation4.mutate,
      mutateAsync = _useMutation4.mutateAsync,
      reset = _useMutation4.reset,
      status = _useMutation4.status,
      variables = _useMutation4.variables;

  var signTypedData = React.useCallback(function (args) {
    return mutate(args || {
      domain: domain,
      types: types,
      value: value
    });
  }, [domain, types, value, mutate]);
  var signTypedDataAsync = React.useCallback(function (args) {
    return mutateAsync(args || {
      domain: domain,
      types: types,
      value: value
    });
  }, [domain, types, value, mutateAsync]);
  return {
    data: data,
    error: error,
    isError: isError,
    isIdle: isIdle,
    isLoading: isLoading,
    isSuccess: isSuccess,
    reset: reset,
    signTypedData: signTypedData,
    signTypedDataAsync: signTypedDataAsync,
    status: status,
    variables: variables
  };
}

var mutationKey$2 = function mutationKey$2(args) {
  return [_objectSpread({
    entity: 'switchNetwork'
  }, args)];
};

var mutationFn$1 = function mutationFn$1(args) {
  var chainId = args.chainId;
  if (!chainId) throw new Error('chainId is required');
  return switchNetwork({
    chainId: chainId
  });
};

function useSwitchNetwork() {
  var _client$connector, _client$chains;

  var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId = _ref21.chainId,
      throwForSwitchChainNotSupported = _ref21.throwForSwitchChainNotSupported,
      onError = _ref21.onError,
      onMutate = _ref21.onMutate,
      onSettled = _ref21.onSettled,
      onSuccess = _ref21.onSuccess;

  var client = useClient();
  var forceUpdate = useForceUpdate();

  var _useMutation5 = useMutation(mutationKey$2({
    chainId: chainId
  }), mutationFn$1, {
    onError: onError,
    onMutate: onMutate,
    onSettled: onSettled,
    onSuccess: onSuccess
  }),
      data = _useMutation5.data,
      error = _useMutation5.error,
      isError = _useMutation5.isError,
      isIdle = _useMutation5.isIdle,
      isLoading = _useMutation5.isLoading,
      isSuccess = _useMutation5.isSuccess,
      mutate = _useMutation5.mutate,
      mutateAsync = _useMutation5.mutateAsync,
      reset = _useMutation5.reset,
      status = _useMutation5.status,
      variables = _useMutation5.variables;

  var switchNetwork_ = React.useCallback(function (chainId_) {
    return mutate({
      chainId: chainId_ !== null && chainId_ !== void 0 ? chainId_ : chainId
    });
  }, [chainId, mutate]);
  var switchNetworkAsync_ = React.useCallback(function (chainId_) {
    return mutateAsync({
      chainId: chainId_ !== null && chainId_ !== void 0 ? chainId_ : chainId
    });
  }, [chainId, mutateAsync]); // Trigger update when connector changes since not all connectors support chain switching

  React.useEffect(function () {
    var unwatch = client.subscribe(function (_ref) {
      var chains = _ref.chains,
          connector = _ref.connector;
      return {
        chains: chains,
        connector: connector
      };
    }, forceUpdate);
    return unwatch;
  }, [client, forceUpdate]);
  var switchNetwork;
  var switchNetworkAsync;
  var supportsSwitchChain = !!((_client$connector = client.connector) !== null && _client$connector !== void 0 && _client$connector.switchChain);

  if (throwForSwitchChainNotSupported || supportsSwitchChain) {
    switchNetwork = switchNetwork_;
    switchNetworkAsync = switchNetworkAsync_;
  }

  return {
    chains: (_client$chains = client.chains) !== null && _client$chains !== void 0 ? _client$chains : [],
    data: data,
    error: error,
    isError: isError,
    isIdle: isIdle,
    isLoading: isLoading,
    isSuccess: isSuccess,
    pendingChainId: variables === null || variables === void 0 ? void 0 : variables.chainId,
    reset: reset,
    status: status,
    switchNetwork: switchNetwork,
    switchNetworkAsync: switchNetworkAsync,
    variables: variables
  };
}

var useContract = function useContract(_ref) {
  var addressOrName = _ref.addressOrName,
      contractInterface = _ref.contractInterface,
      signerOrProvider = _ref.signerOrProvider;
  return React.useMemo(function () {
    return getContract({
      addressOrName: addressOrName,
      contractInterface: contractInterface,
      signerOrProvider: signerOrProvider
    });
  }, [addressOrName, contractInterface, signerOrProvider]);
};

var useContractEvent = function useContractEvent(_ref) {
  var _ref2;

  var addressOrName = _ref.addressOrName,
      chainId = _ref.chainId,
      contractInterface = _ref.contractInterface,
      listener = _ref.listener,
      eventName = _ref.eventName,
      signerOrProvider = _ref.signerOrProvider,
      once = _ref.once;
  var provider = useProvider({
    chainId: chainId
  });
  var webSocketProvider = useWebSocketProvider({
    chainId: chainId
  });
  var contract = useContract({
    addressOrName: addressOrName,
    contractInterface: contractInterface,
    signerOrProvider: (_ref2 = webSocketProvider !== null && webSocketProvider !== void 0 ? webSocketProvider : provider) !== null && _ref2 !== void 0 ? _ref2 : signerOrProvider
  });
  var listenerRef = React.useRef(listener);
  listenerRef.current = listener;
  React.useEffect(function () {
    var handler = function handler() {
      for (var _len = arguments.length, event = new Array(_len), _key = 0; _key < _len; _key++) {
        event[_key] = arguments[_key];
      }

      return listenerRef.current(event);
    };

    var contract_ = contract;
    if (once) contract_.once(eventName, handler);else contract_.on(eventName, handler);
    return function () {
      contract_.off(eventName, handler);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contract, eventName]);
};

var paginatedIndexesConfig = function paginatedIndexesConfig(fn, _ref) {
  var perPage = _ref.perPage,
      start = _ref.start,
      direction = _ref.direction;
  return {
    getNextPageParam: function getNextPageParam(lastPage, pages) {
      return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) === perPage ? pages.length : undefined;
    },
    contracts: function contracts() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      return _toConsumableArray(Array(perPage).keys()).map(function (index) {
        return direction === 'increment' ? start + index + page * perPage : start - index - page * perPage;
      }).filter(function (index) {
        return index >= 0;
      }).map(fn);
    }
  };
};

var queryKey$8 = function queryKey$8(_ref2) {
  var _ref22 = _slicedToArray(_ref2, 1),
      _ref22$ = _ref22[0],
      cacheKey = _ref22$.cacheKey,
      overrides = _ref22$.overrides;

  return [{
    entity: 'readContractsInfinite',
    cacheKey: cacheKey,
    overrides: overrides
  }];
};

var queryFn$8 = function queryFn$8(_ref3) {
  var contracts = _ref3.contracts;
  return function (_ref4) {
    var _ref4$queryKey = _slicedToArray(_ref4.queryKey, 1),
        overrides = _ref4$queryKey[0].overrides,
        pageParam = _ref4.pageParam;

    return readContracts({
      contracts: contracts(pageParam || undefined),
      overrides: overrides
    });
  };
};

function useContractInfiniteReads(_ref5) {
  var cacheKey = _ref5.cacheKey,
      cacheTime = _ref5.cacheTime,
      contracts = _ref5.contracts,
      _ref5$enabled = _ref5.enabled,
      enabled_ = _ref5$enabled === void 0 ? true : _ref5$enabled,
      getNextPageParam = _ref5.getNextPageParam,
      _ref5$isDataEqual = _ref5.isDataEqual,
      isDataEqual = _ref5$isDataEqual === void 0 ? deepEqual : _ref5$isDataEqual,
      keepPreviousData = _ref5.keepPreviousData,
      onError = _ref5.onError,
      onSettled = _ref5.onSettled,
      onSuccess = _ref5.onSuccess,
      overrides = _ref5.overrides,
      select = _ref5.select,
      staleTime = _ref5.staleTime,
      suspense = _ref5.suspense;
  var queryKey_ = React.useMemo(function () {
    return queryKey$8([{
      cacheKey: cacheKey,
      overrides: overrides
    }]);
  }, [cacheKey, overrides]);
  var enabled = React.useMemo(function () {
    var enabled = Boolean(enabled_ && contracts);
    return enabled;
  }, [contracts, enabled_]);
  return useInfiniteQuery(queryKey_, queryFn$8({
    contracts: contracts
  }), {
    cacheTime: cacheTime,
    enabled: enabled,
    getNextPageParam: getNextPageParam,
    isDataEqual: isDataEqual,
    keepPreviousData: keepPreviousData,
    select: select,
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
}

var queryKey$7 = function queryKey$7(_ref) {
  var _ref23 = _slicedToArray(_ref, 2),
      _ref23$ = _ref23[0],
      addressOrName = _ref23$.addressOrName,
      args = _ref23$.args,
      chainId = _ref23$.chainId,
      contractInterface = _ref23$.contractInterface,
      functionName = _ref23$.functionName,
      overrides = _ref23$.overrides,
      blockNumber = _ref23[1].blockNumber;

  return [{
    entity: 'readContract',
    addressOrName: addressOrName,
    args: args,
    blockNumber: blockNumber,
    chainId: chainId,
    contractInterface: contractInterface,
    functionName: functionName,
    overrides: overrides
  }];
};

var queryKeyHashFn$1 = function queryKeyHashFn$1(_ref2) {
  var _ref24 = _slicedToArray(_ref2, 1),
      queryKey_ = _ref24[0]; // eslint-disable-next-line @typescript-eslint/no-unused-vars


  var contractInterface = queryKey_.contractInterface,
      rest = _objectWithoutProperties(queryKey_, ["contractInterface"]);

  return hashQueryKey([rest]);
};

var queryFn$7 = function queryFn$7(_ref3) {
  var _ref3$queryKey = _slicedToArray(_ref3.queryKey, 1),
      _ref3$queryKey$ = _ref3$queryKey[0],
      addressOrName = _ref3$queryKey$.addressOrName,
      args = _ref3$queryKey$.args,
      chainId = _ref3$queryKey$.chainId,
      contractInterface = _ref3$queryKey$.contractInterface,
      functionName = _ref3$queryKey$.functionName,
      overrides = _ref3$queryKey$.overrides;

  return readContract({
    addressOrName: addressOrName,
    args: args,
    chainId: chainId,
    contractInterface: contractInterface,
    functionName: functionName,
    overrides: overrides
  });
};

function useContractRead(_ref4) {
  var addressOrName = _ref4.addressOrName,
      contractInterface = _ref4.contractInterface,
      functionName = _ref4.functionName,
      args = _ref4.args,
      chainId_ = _ref4.chainId,
      overrides = _ref4.overrides,
      _ref4$cacheOnBlock = _ref4.cacheOnBlock,
      cacheOnBlock = _ref4$cacheOnBlock === void 0 ? false : _ref4$cacheOnBlock,
      cacheTime = _ref4.cacheTime,
      _ref4$enabled = _ref4.enabled,
      enabled_ = _ref4$enabled === void 0 ? true : _ref4$enabled,
      _ref4$isDataEqual = _ref4.isDataEqual,
      isDataEqual = _ref4$isDataEqual === void 0 ? deepEqual : _ref4$isDataEqual,
      _select = _ref4.select,
      staleTime = _ref4.staleTime,
      suspense = _ref4.suspense,
      watch = _ref4.watch,
      onError = _ref4.onError,
      onSettled = _ref4.onSettled,
      onSuccess = _ref4.onSuccess;
  var chainId = useChainId({
    chainId: chainId_
  });

  var _useBlockNumber3 = useBlockNumber({
    enabled: watch || cacheOnBlock,
    watch: watch
  }),
      blockNumber = _useBlockNumber3.data;

  var queryKey_ = React.useMemo(function () {
    return queryKey$7([{
      addressOrName: addressOrName,
      args: args,
      chainId: chainId,
      contractInterface: contractInterface,
      functionName: functionName,
      overrides: overrides
    }, {
      blockNumber: cacheOnBlock ? blockNumber : undefined
    }]);
  }, [addressOrName, args, blockNumber, cacheOnBlock, chainId, contractInterface, functionName, overrides]);
  var enabled = React.useMemo(function () {
    var enabled = Boolean(enabled_ && addressOrName && functionName);
    if (cacheOnBlock) enabled = Boolean(enabled && blockNumber);
    return enabled;
  }, [addressOrName, blockNumber, cacheOnBlock, enabled_, functionName]);
  useInvalidateOnBlock({
    enabled: watch && !cacheOnBlock,
    queryKey: queryKey_
  });
  return useQuery(queryKey_, queryFn$7, {
    cacheTime: cacheTime,
    enabled: enabled,
    isDataEqual: isDataEqual,
    queryKeyHashFn: queryKeyHashFn$1,
    select: function select(data) {
      var result = parseContractResult({
        contractInterface: contractInterface,
        data: data,
        functionName: functionName
      });
      return _select ? _select(result) : result;
    },
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
}

var queryKey$6 = function queryKey$6(_ref) {
  var _ref25 = _slicedToArray(_ref, 2),
      _ref25$ = _ref25[0],
      allowFailure = _ref25$.allowFailure,
      contracts = _ref25$.contracts,
      overrides = _ref25$.overrides,
      _ref25$2 = _ref25[1],
      blockNumber = _ref25$2.blockNumber,
      chainId = _ref25$2.chainId;

  return [{
    entity: 'readContracts',
    allowFailure: allowFailure,
    blockNumber: blockNumber,
    chainId: chainId,
    contracts: contracts,
    overrides: overrides
  }];
};

var queryKeyHashFn = function queryKeyHashFn(_ref2) {
  var _ref26 = _slicedToArray(_ref2, 1),
      queryKey_ = _ref26[0];

  var contracts = queryKey_.contracts,
      rest = _objectWithoutProperties(queryKey_, ["contracts"]);

  var contracts_ = contracts === null || contracts === void 0 ? void 0 : contracts.map(function (contract) {
    // Exclude the contract interface from the serialized query key.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var contractInterface = contract.contractInterface,
        rest = _objectWithoutProperties(contract, ["contractInterface"]);

    return rest;
  });
  return hashQueryKey([_objectSpread({
    contracts: contracts_
  }, rest)]);
};

var queryFn$6 = function queryFn$6(_ref3) {
  var _ref3$queryKey2 = _slicedToArray(_ref3.queryKey, 1),
      _ref3$queryKey2$ = _ref3$queryKey2[0],
      allowFailure = _ref3$queryKey2$.allowFailure,
      contracts = _ref3$queryKey2$.contracts,
      overrides = _ref3$queryKey2$.overrides;

  return readContracts({
    allowFailure: allowFailure,
    contracts: contracts,
    overrides: overrides
  });
};

function useContractReads(_ref4) {
  var _ref4$allowFailure = _ref4.allowFailure,
      allowFailure = _ref4$allowFailure === void 0 ? true : _ref4$allowFailure,
      _ref4$cacheOnBlock2 = _ref4.cacheOnBlock,
      cacheOnBlock = _ref4$cacheOnBlock2 === void 0 ? false : _ref4$cacheOnBlock2,
      cacheTime = _ref4.cacheTime,
      contracts = _ref4.contracts,
      overrides = _ref4.overrides,
      _ref4$enabled2 = _ref4.enabled,
      enabled_ = _ref4$enabled2 === void 0 ? true : _ref4$enabled2,
      _ref4$isDataEqual2 = _ref4.isDataEqual,
      isDataEqual = _ref4$isDataEqual2 === void 0 ? deepEqual : _ref4$isDataEqual2,
      keepPreviousData = _ref4.keepPreviousData,
      onError = _ref4.onError,
      onSettled = _ref4.onSettled,
      onSuccess = _ref4.onSuccess,
      _select2 = _ref4.select,
      staleTime = _ref4.staleTime,
      suspense = _ref4.suspense,
      watch = _ref4.watch;

  var _useBlockNumber4 = useBlockNumber({
    enabled: watch || cacheOnBlock,
    watch: watch
  }),
      blockNumber = _useBlockNumber4.data;

  var chainId = useChainId();
  var queryKey_ = React.useMemo(function () {
    return queryKey$6([{
      allowFailure: allowFailure,
      contracts: contracts,
      overrides: overrides
    }, {
      blockNumber: cacheOnBlock ? blockNumber : undefined,
      chainId: chainId
    }]);
  }, [allowFailure, blockNumber, cacheOnBlock, chainId, contracts, overrides]);
  var enabled = React.useMemo(function () {
    var enabled = Boolean(enabled_ && contracts.length > 0);
    if (cacheOnBlock) enabled = Boolean(enabled && blockNumber);
    return enabled;
  }, [blockNumber, cacheOnBlock, contracts, enabled_]);
  useInvalidateOnBlock({
    enabled: watch && !cacheOnBlock,
    queryKey: queryKey_
  });
  return useQuery(queryKey_, queryFn$6, {
    cacheTime: cacheTime,
    enabled: enabled,
    isDataEqual: isDataEqual,
    keepPreviousData: keepPreviousData,
    queryKeyHashFn: queryKeyHashFn,
    staleTime: staleTime,
    select: function select(data) {
      var result = data.map(function (data, i) {
        var _contracts$i, _contracts$i2;

        return contracts[i] ? parseContractResult({
          contractInterface: (_contracts$i = contracts[i]) === null || _contracts$i === void 0 ? void 0 : _contracts$i.contractInterface,
          functionName: (_contracts$i2 = contracts[i]) === null || _contracts$i2 === void 0 ? void 0 : _contracts$i2.functionName,
          data: data
        }) : data;
      });
      return _select2 ? _select2(result) : result;
    },
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
}

var mutationKey$1 = function mutationKey$1(_ref) {
  var _ref27 = _slicedToArray(_ref, 1),
      _ref27$ = _ref27[0],
      addressOrName = _ref27$.addressOrName,
      args = _ref27$.args,
      chainId = _ref27$.chainId,
      contractInterface = _ref27$.contractInterface,
      overrides = _ref27$.overrides;

  return [{
    entity: 'writeContract',
    addressOrName: addressOrName,
    args: args,
    chainId: chainId,
    contractInterface: contractInterface,
    overrides: overrides
  }];
};

function useContractWrite(_ref2) {
  var addressOrName = _ref2.addressOrName,
      args = _ref2.args,
      chainId = _ref2.chainId,
      contractInterface = _ref2.contractInterface,
      functionName = _ref2.functionName,
      overrides = _ref2.overrides,
      signerOrProvider = _ref2.signerOrProvider,
      onError = _ref2.onError,
      onMutate = _ref2.onMutate,
      onSettled = _ref2.onSettled,
      onSuccess = _ref2.onSuccess;

  var _useMutation6 = useMutation(mutationKey$1([{
    addressOrName: addressOrName,
    args: args,
    chainId: chainId,
    contractInterface: contractInterface,
    functionName: functionName,
    overrides: overrides
  }]), function (_ref3) {
    var args = _ref3.args,
        overrides = _ref3.overrides;
    return writeContract({
      addressOrName: addressOrName,
      args: args,
      chainId: chainId,
      contractInterface: contractInterface,
      functionName: functionName,
      overrides: overrides,
      signerOrProvider: signerOrProvider
    });
  }, {
    onError: onError,
    onMutate: onMutate,
    onSettled: onSettled,
    onSuccess: onSuccess
  }),
      data = _useMutation6.data,
      error = _useMutation6.error,
      isError = _useMutation6.isError,
      isIdle = _useMutation6.isIdle,
      isLoading = _useMutation6.isLoading,
      isSuccess = _useMutation6.isSuccess,
      mutate = _useMutation6.mutate,
      mutateAsync = _useMutation6.mutateAsync,
      reset = _useMutation6.reset,
      status = _useMutation6.status,
      variables = _useMutation6.variables;

  var write = React.useCallback(function (overrideConfig) {
    return mutate(_objectSpread({
      addressOrName: addressOrName,
      chainId: chainId,
      contractInterface: contractInterface,
      functionName: functionName,
      signerOrProvider: signerOrProvider
    }, overrideConfig || {
      args: args,
      overrides: overrides
    }));
  }, [addressOrName, args, chainId, contractInterface, functionName, mutate, overrides, signerOrProvider]);
  var writeAsync = React.useCallback(function (overrideConfig) {
    return mutateAsync(_objectSpread({
      addressOrName: addressOrName,
      chainId: chainId,
      contractInterface: contractInterface,
      functionName: functionName,
      signerOrProvider: signerOrProvider
    }, overrideConfig || {
      args: args,
      overrides: overrides
    }));
  }, [addressOrName, args, chainId, contractInterface, functionName, mutateAsync, overrides, signerOrProvider]);
  return {
    data: data,
    error: error,
    isError: isError,
    isIdle: isIdle,
    isLoading: isLoading,
    isSuccess: isSuccess,
    reset: reset,
    status: status,
    variables: variables,
    write: write,
    writeAsync: writeAsync
  };
}

var queryKey$5 = function queryKey$5(_ref) {
  var address = _ref.address,
      chainId = _ref.chainId,
      formatUnits = _ref.formatUnits;
  return [{
    entity: 'token',
    address: address,
    chainId: chainId,
    formatUnits: formatUnits
  }];
};

var queryFn$5 = function queryFn$5(_ref2) {
  var _ref2$queryKey4 = _slicedToArray(_ref2.queryKey, 1),
      _ref2$queryKey4$ = _ref2$queryKey4[0],
      address = _ref2$queryKey4$.address,
      chainId = _ref2$queryKey4$.chainId,
      formatUnits = _ref2$queryKey4$.formatUnits;

  if (!address) throw new Error('address is required');
  return fetchToken({
    address: address,
    chainId: chainId,
    formatUnits: formatUnits
  });
};

function useToken() {
  var _ref28 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      address = _ref28.address,
      chainId_ = _ref28.chainId,
      _ref28$formatUnits = _ref28.formatUnits,
      formatUnits = _ref28$formatUnits === void 0 ? 'ether' : _ref28$formatUnits,
      cacheTime = _ref28.cacheTime,
      _ref28$enabled = _ref28.enabled,
      enabled = _ref28$enabled === void 0 ? true : _ref28$enabled,
      _ref28$staleTime = _ref28.staleTime,
      staleTime = _ref28$staleTime === void 0 ? 1000 * 60 * 60 * 24 : _ref28$staleTime,
      suspense = _ref28.suspense,
      onError = _ref28.onError,
      onSettled = _ref28.onSettled,
      onSuccess = _ref28.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  return useQuery(queryKey$5({
    address: address,
    chainId: chainId,
    formatUnits: formatUnits
  }), queryFn$5, {
    cacheTime: cacheTime,
    enabled: Boolean(enabled && address),
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
}

var queryKey$4 = function queryKey$4(_ref) {
  var chainId = _ref.chainId,
      name = _ref.name;
  return [{
    entity: 'ensAddress',
    chainId: chainId,
    name: name
  }];
};

var queryFn$4 = function queryFn$4(_ref2) {
  var _ref2$queryKey5 = _slicedToArray(_ref2.queryKey, 1),
      _ref2$queryKey5$ = _ref2$queryKey5[0],
      chainId = _ref2$queryKey5$.chainId,
      name = _ref2$queryKey5$.name;

  if (!name) throw new Error('name is required');
  return fetchEnsAddress({
    chainId: chainId,
    name: name
  });
};

function useEnsAddress() {
  var _ref29 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      cacheTime = _ref29.cacheTime,
      chainId_ = _ref29.chainId,
      _ref29$enabled = _ref29.enabled,
      enabled = _ref29$enabled === void 0 ? true : _ref29$enabled,
      name = _ref29.name,
      _ref29$staleTime = _ref29.staleTime,
      staleTime = _ref29$staleTime === void 0 ? 1000 * 60 * 60 * 24 : _ref29$staleTime,
      suspense = _ref29.suspense,
      onError = _ref29.onError,
      onSettled = _ref29.onSettled,
      onSuccess = _ref29.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  return useQuery(queryKey$4({
    chainId: chainId,
    name: name
  }), queryFn$4, {
    cacheTime: cacheTime,
    enabled: Boolean(enabled && chainId && name),
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
}

var queryKey$3 = function queryKey$3(_ref) {
  var addressOrName = _ref.addressOrName,
      chainId = _ref.chainId;
  return [{
    entity: 'ensAvatar',
    addressOrName: addressOrName,
    chainId: chainId
  }];
};

var queryFn$3 = function queryFn$3(_ref2) {
  var _ref2$queryKey6 = _slicedToArray(_ref2.queryKey, 1),
      _ref2$queryKey6$ = _ref2$queryKey6[0],
      addressOrName = _ref2$queryKey6$.addressOrName,
      chainId = _ref2$queryKey6$.chainId;

  if (!addressOrName) throw new Error('addressOrName is required');
  return fetchEnsAvatar({
    addressOrName: addressOrName,
    chainId: chainId
  });
};

function useEnsAvatar() {
  var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      addressOrName = _ref30.addressOrName,
      cacheTime = _ref30.cacheTime,
      chainId_ = _ref30.chainId,
      _ref30$enabled = _ref30.enabled,
      enabled = _ref30$enabled === void 0 ? true : _ref30$enabled,
      _ref30$staleTime = _ref30.staleTime,
      staleTime = _ref30$staleTime === void 0 ? 1000 * 60 * 60 * 24 : _ref30$staleTime,
      suspense = _ref30.suspense,
      onError = _ref30.onError,
      onSettled = _ref30.onSettled,
      onSuccess = _ref30.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  return useQuery(queryKey$3({
    addressOrName: addressOrName,
    chainId: chainId
  }), queryFn$3, {
    cacheTime: cacheTime,
    enabled: Boolean(enabled && addressOrName && chainId),
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
}

var queryKey$2 = function queryKey$2(_ref) {
  var address = _ref.address,
      chainId = _ref.chainId;
  return [{
    entity: 'ensName',
    address: address,
    chainId: chainId
  }];
};

var queryFn$2 = function queryFn$2(_ref2) {
  var _ref2$queryKey7 = _slicedToArray(_ref2.queryKey, 1),
      _ref2$queryKey7$ = _ref2$queryKey7[0],
      address = _ref2$queryKey7$.address,
      chainId = _ref2$queryKey7$.chainId;

  if (!address) throw new Error('address is required');
  return fetchEnsName({
    address: address,
    chainId: chainId
  });
};

function useEnsName() {
  var _ref31 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      address = _ref31.address,
      cacheTime = _ref31.cacheTime,
      chainId_ = _ref31.chainId,
      _ref31$enabled = _ref31.enabled,
      enabled = _ref31$enabled === void 0 ? true : _ref31$enabled,
      _ref31$staleTime = _ref31.staleTime,
      staleTime = _ref31$staleTime === void 0 ? 1000 * 60 * 60 * 24 : _ref31$staleTime,
      suspense = _ref31.suspense,
      onError = _ref31.onError,
      onSettled = _ref31.onSettled,
      onSuccess = _ref31.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  return useQuery(queryKey$2({
    address: address,
    chainId: chainId
  }), queryFn$2, {
    cacheTime: cacheTime,
    enabled: Boolean(enabled && address && chainId),
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
}

var queryKey$1 = function queryKey$1(_ref) {
  var chainId = _ref.chainId,
      name = _ref.name;
  return [{
    entity: 'ensResolver',
    chainId: chainId,
    name: name
  }];
};

var queryFn$1 = function queryFn$1(_ref2) {
  var _ref2$queryKey8 = _slicedToArray(_ref2.queryKey, 1),
      _ref2$queryKey8$ = _ref2$queryKey8[0],
      chainId = _ref2$queryKey8$.chainId,
      name = _ref2$queryKey8$.name;

  if (!name) throw new Error('name is required');
  return fetchEnsResolver({
    chainId: chainId,
    name: name
  });
};

function useEnsResolver() {
  var _ref32 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      cacheTime = _ref32.cacheTime,
      chainId_ = _ref32.chainId,
      _ref32$enabled = _ref32.enabled,
      enabled = _ref32$enabled === void 0 ? true : _ref32$enabled,
      name = _ref32.name,
      _ref32$staleTime = _ref32.staleTime,
      staleTime = _ref32$staleTime === void 0 ? 1000 * 60 * 60 * 24 : _ref32$staleTime,
      suspense = _ref32.suspense,
      onError = _ref32.onError,
      onSettled = _ref32.onSettled,
      onSuccess = _ref32.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  return useQuery(queryKey$1({
    chainId: chainId,
    name: name
  }), queryFn$1, {
    cacheTime: cacheTime,
    enabled: Boolean(enabled && chainId && name),
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
}

var mutationKey = function mutationKey(args) {
  return [_objectSpread({
    entity: 'sendTransaction'
  }, args)];
};

var mutationFn = function mutationFn(args) {
  var chainId = args.chainId,
      request = args.request;
  if (!request) throw new Error('request is required');
  return sendTransaction({
    chainId: chainId,
    request: request
  });
};

function useSendTransaction() {
  var _ref33 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId = _ref33.chainId,
      request = _ref33.request,
      onError = _ref33.onError,
      onMutate = _ref33.onMutate,
      onSettled = _ref33.onSettled,
      onSuccess = _ref33.onSuccess;

  var _useMutation7 = useMutation(mutationKey({
    chainId: chainId,
    request: request
  }), mutationFn, {
    onError: onError,
    onMutate: onMutate,
    onSettled: onSettled,
    onSuccess: onSuccess
  }),
      data = _useMutation7.data,
      error = _useMutation7.error,
      isError = _useMutation7.isError,
      isIdle = _useMutation7.isIdle,
      isLoading = _useMutation7.isLoading,
      isSuccess = _useMutation7.isSuccess,
      mutate = _useMutation7.mutate,
      mutateAsync = _useMutation7.mutateAsync,
      reset = _useMutation7.reset,
      status = _useMutation7.status,
      variables = _useMutation7.variables;

  var sendTransaction = React.useCallback(function (args) {
    return mutate(_objectSpread({
      chainId: chainId,
      request: request
    }, args !== null && args !== void 0 ? args : {}));
  }, [chainId, mutate, request]);
  var sendTransactionAsync = React.useCallback(function (args) {
    return mutateAsync(_objectSpread({
      chainId: chainId,
      request: request
    }, args !== null && args !== void 0 ? args : {}));
  }, [chainId, mutateAsync, request]);
  return {
    data: data,
    error: error,
    isError: isError,
    isIdle: isIdle,
    isLoading: isLoading,
    isSuccess: isSuccess,
    reset: reset,
    sendTransaction: sendTransaction,
    sendTransactionAsync: sendTransactionAsync,
    status: status,
    variables: variables
  };
}

var queryKey = function queryKey(_ref) {
  var confirmations = _ref.confirmations,
      chainId = _ref.chainId,
      hash = _ref.hash,
      timeout = _ref.timeout,
      wait = _ref.wait;
  return [{
    entity: 'waitForTransaction',
    confirmations: confirmations,
    chainId: chainId,
    hash: hash,
    timeout: timeout,
    wait: wait
  }];
};

var queryFn = function queryFn(_ref2) {
  var _ref2$queryKey9 = _slicedToArray(_ref2.queryKey, 1),
      _ref2$queryKey9$ = _ref2$queryKey9[0],
      chainId = _ref2$queryKey9$.chainId,
      confirmations = _ref2$queryKey9$.confirmations,
      hash = _ref2$queryKey9$.hash,
      timeout = _ref2$queryKey9$.timeout,
      wait = _ref2$queryKey9$.wait;

  return waitForTransaction({
    chainId: chainId,
    confirmations: confirmations,
    hash: hash,
    timeout: timeout,
    wait: wait
  });
};

function useWaitForTransaction() {
  var _ref34 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId_ = _ref34.chainId,
      confirmations = _ref34.confirmations,
      hash = _ref34.hash,
      timeout = _ref34.timeout,
      wait = _ref34.wait,
      cacheTime = _ref34.cacheTime,
      _ref34$enabled = _ref34.enabled,
      enabled = _ref34$enabled === void 0 ? true : _ref34$enabled,
      staleTime = _ref34.staleTime,
      suspense = _ref34.suspense,
      onError = _ref34.onError,
      onSettled = _ref34.onSettled,
      onSuccess = _ref34.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  return useQuery(queryKey({
    chainId: chainId,
    confirmations: confirmations,
    hash: hash,
    timeout: timeout,
    wait: wait
  }), queryFn, {
    cacheTime: cacheTime,
    enabled: Boolean(enabled && (hash || wait)),
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
}

export { Context, WagmiConfig, WagmiConfig as WagmiProvider, createClient, deserialize, paginatedIndexesConfig, serialize, useAccount, useBalance, useBlockNumber, useClient, useConnect, useContract, useContractEvent, useContractInfiniteReads, useContractRead, useContractReads, useContractWrite, useDisconnect, useEnsAddress, useEnsAvatar, useEnsName, useEnsResolver, useFeeData, useInfiniteQuery, useNetwork, useProvider, useQuery, useSendTransaction, useSignMessage, useSignTypedData, useSigner, useSwitchNetwork, useToken, useWaitForTransaction, useWebSocketProvider };